import { useFeatureFlags } from 'utils/features';

export const useEmployeePickerFilterPosition = () => useFeatureFlags('EMPLOYEE_PICKER_FILTER_POSITION');

export const useEmployeePickerFilterCertification = () => useFeatureFlags('EMPLOYEE_PICKER_FILTER_CERTIFICATION');

export const useEmployeePickerFilters = () => {
  const filterPosition = useEmployeePickerFilterPosition();
  const filterCertification = useEmployeePickerFilterCertification();

  return filterPosition || filterCertification;
};
